import React, {useState, useRef, useEffect} from "react";
import {useSelector} from "react-redux";
import {useActivate, useUnactivate} from "react-activation";
import {message, Modal, Breadcrumb, Space, Button, Form, Row, Col, Input, Table} from "antd";
import {FileAddOutlined, DeleteOutlined, CloseCircleOutlined, FileSearchOutlined, FileTextOutlined} from "@ant-design/icons";
import ChuangShiOS from "chuangshi-os-website-component";

import Application from "../../common/Application";

import Style from "./Index.module.css";

const BrandIndex = (props) => {
    const store = useSelector((store) => store);
    const [form] = Form.useForm();
    const request = useRef(false);
    const [isLoad, setIsLoad] = useState(false);
    const [isError, setIsError] = useState(false);
    const [tableHeight, setTableHeight] = useState(0);
    const [brandPageIndex, setBrandPageIndex] = useState(1);
    const [brandPageSize, setBrandPageSize] = useState(store.main.pageSize);
    const [brandIdList, setBrandIdList] = useState([]);
    const [brandTotal, setBrandTotal] = useState(0);
    const [brandList, setBrandList] = useState([]);

    useEffect(() => {
        if (store.main.userName) {
            ChuangShiOS.Notification.emit("main_menu_active", {url: "/brand/index"});

            handleSearchBrand();
        }

        //eslint-disable-next-line
    }, [store.main.userName]);

    useEffect(() => {
        handleLoadBrand(brandPageIndex, store.main.pageSize);

        //eslint-disable-next-line
    }, [store.main.pageSize]);

    useActivate(() => {
        ChuangShiOS.Notification.emit("main_set_scroll_top", {});

        handleLoadBrand(brandPageIndex, brandPageSize);
    });

    useUnactivate(() => {
        ChuangShiOS.Notification.emit("main_get_scroll_top", {});
    });

    const handleSearchBrand = () => {
        handleLoadBrand(1, brandPageSize);
    };

    const handleLoadBrand = (brandPageIndex, brandPageSize) => {
        if (request.current) {
            return;
        }
        request.current = true;

        setIsLoad(true);

        let data = form.getFieldsValue();
        data.pageIndex = brandPageIndex;
        data.pageSize = brandPageSize;

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/brand/business/website/v1/list",
            data: data,
            success: (response) => {
                setBrandPageIndex(brandPageIndex);
                setBrandPageSize(brandPageSize);
                setBrandIdList([]);
                setBrandTotal(response.data.total);
                setBrandList(response.data.list);
            },
            error: (response) => {
                message.error({content: response.message, duration: 1});
            },
            complete: (response) => {
                request.current = false;

                setIsLoad(false);
                setIsError(
                    typeof response.data == "undefined" ||
                        response.data.total == "undefined" ||
                        response.data.total == null ||
                        response.data.list == "undefined" ||
                        response.data.list == null
                );
            },
        });
    };

    const handleAddBrand = () => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/brand/add",
        });
    };

    const handleEditBrand = (brandId) => {
        ChuangShiOS.Util.navigateTo(props, {
            url: "/brand/edit/" + brandId,
        });
    };

    const handleDelBrand = () => {
        if (brandIdList.length == 0) {
            return;
        }

        if (request.current) {
            return;
        }

        Modal.confirm({
            title: "是否确认操作？",
            content: "本次数据操作后将无法恢复",
            okText: "确认",
            okType: "danger",
            okButtonProps: {
                icon: <DeleteOutlined />,
            },
            cancelText: "取消",
            cancelButtonProps: {
                icon: <CloseCircleOutlined />,
            },
            onOk: () => {
                if (request.current) {
                    return;
                }
                request.current = true;

                setIsLoad(true);

                message.loading({
                    content: "正在加载",
                    key: "isLoad",
                    duration: 0,
                });

                ChuangShiOS.Util.request(props, {
                    url: Application.host + "/windeal/brand/business/website/v1/delete",
                    data: {
                        brandIdList: brandIdList,
                    },
                    success: (response) => {
                        message.success({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                        setBrandIdList([]);

                        handleLoadBrand(brandPageIndex, brandPageSize);
                    },
                    error: (response) => {
                        message.error({
                            content: response.message,
                            key: "isLoad",
                            duration: 2,
                        });

                        request.current = false;

                        setIsLoad(false);
                    },
                    complete: (response) => {},
                });
            },
        });
    };

    const handleChangeBrandIdList = (brandIdList) => {
        setBrandIdList(brandIdList);
    };

    const handleChangeBrandPagination = (brandPageIndex, brandPageSize) => {
        handleLoadBrand(brandPageIndex, brandPageSize);
    };

    return (
        <div className={Style.page}>
            <div className={Style.header}>
                <div className={Style.header_title}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <span>首页</span>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <span>{store.main.menuName}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className={Style.header_title_text}>{store.main.sidebarName}</div>
                </div>
                <div className={Style.header_button}>
                    <Space>
                        <Button.Group>
                            <Button icon={<FileAddOutlined />} size="large" onClick={handleAddBrand}>
                                新增
                            </Button>
                            <Button
                                loading={isLoad}
                                disabled={brandIdList.length == 0}
                                icon={<DeleteOutlined />}
                                size="large"
                                onClick={handleDelBrand}
                            >
                                删除
                            </Button>
                        </Button.Group>
                        <Button loading={isLoad} icon={<FileSearchOutlined />} type="primary" size="large" onClick={handleSearchBrand}>
                            查询
                        </Button>
                    </Space>
                </div>
            </div>
            <ChuangShiOS.Content className={Style.content} isLoad={isLoad} isEmpty={false} isError={isError} isScroll={store.main.isFixedContent}>
                <Form form={form}>
                    <Row>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="品牌名称"
                                labelAlign={"left"}
                                name="brandName"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入品牌名称",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入品牌名称" onPressEnter={handleSearchBrand} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                {...{
                                    labelCol: {flex: "none"},
                                    wrapperCol: {flex: "auto"},
                                }}
                                label="品牌代码"
                                labelAlign={"left"}
                                name="brandCode"
                                initialValue={""}
                                rules={[
                                    {
                                        required: false,
                                        message: "请输入品牌代码",
                                    },
                                ]}
                            >
                                <Input className={Style.card_field} placeholder="请输入品牌代码" onPressEnter={handleSearchBrand} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <div
                    ref={(ref) => {
                        if (ref != null && tableHeight == 0 && tableHeight != ref.clientHeight) {
                            setTableHeight(ref.clientHeight);
                        }
                    }}
                    className={store.main.isFixedContent ? Style.card_table : null}
                >
                    <Table
                        size="small"
                        rowKey={(record) => record.brandId}
                        columns={[
                            {
                                title: "品牌名称",
                                dataIndex: "brandName",
                            },
                            {
                                title: "品牌代码",
                                dataIndex: "brandCode",
                            },
                            {
                                title: "操作",
                                width: 150,
                                render: (text, record, recordIndex) => (
                                    <Space>
                                        <Button icon={<FileTextOutlined />} size="default" onClick={() => handleEditBrand(record.brandId)}>
                                            修改
                                        </Button>
                                    </Space>
                                ),
                            },
                        ]}
                        dataSource={brandList}
                        rowSelection={{
                            fixed: true,
                            selectedRowKeys: brandIdList,
                            onChange: handleChangeBrandIdList,
                        }}
                        scroll={store.main.isFixedContent ? {y: tableHeight - 130} : {}}
                        pagination={{
                            size: "default",
                            showQuickJumper: true,
                            showSizeChanger: true,
                            current: brandPageIndex,
                            pageSize: brandPageSize,
                            total: brandTotal,
                            showTotal: (total, range) => "显示" + range[0] + "到" + range[1] + "条,共有" + total + "条",
                            onChange: handleChangeBrandPagination,
                            onShowSizeChange: handleChangeBrandPagination,
                        }}
                    />
                </div>
            </ChuangShiOS.Content>
            <div className={Style.footer}></div>
        </div>
    );
};

BrandIndex.propTypes = {};

BrandIndex.defaultProps = {};

export default BrandIndex;
